import AxiosClient from '@/repositories/clients/axiosCsExternal'

const matchResource = '/workflowsByMatches'

const findByMatch = (queryParams = '', organization) => AxiosClient.get(
  `${matchResource}?${queryParams}`, { headers: { organization } }
)

export {
  findByMatch
}
